module.exports = __webpack_public_path__ + "img/ShortSt_trim01.33dae20e.gif";